// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__z0Q-i"};